// extracted by mini-css-extract-plugin
export default {"Select":"Select_Select__ktOuc"};